import React ,{useContext,useState,useEffect}from "react";
import helpers from "../utils/helpers";
import jwt_decode from "jwt-decode";
import AuthContext from "../context/AuthContext";
import { toast } from "wc-toast";
import { useForm } from "react-hook-form";
import {
  Container,
  Row,
  Col,
  Table,
  Modal,
  Button,
  Form,
} from "react-bootstrap";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import moment from "moment";

const DashboardNew = () => {
  
  const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
      setValue,
      watch,
    } = useForm({});
const [profileData, setProfileData] = useState("");
  const { user } = useContext(AuthContext);
  const [code, setCode] = useState({
      status: false,
      item: "",
    });
  //  console.log(user,profileData?.referalCode,'user')
     const handleCopy = () => {
    navigator.clipboard
      .writeText('https://'+helpers?.getDomain()+'/register/?referral_code='+profileData?.referalCode)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  const myProfile = async () => {
    const { status, data: response_users } = await apiGet(apiPath.userProfile);
    if (status === 200) {
      if (response_users.success) {
        setProfileData(response_users.results);
      }
    }
  };
   const updateRefrel = async (request) => {
    const { status, data: response_users } = await apiPost(
      apiPath.updateRefrelCode,
      { referalCode: request?.referalCode }
    );
    if (status === 200) {
      if (response_users.success) {
        toast.success(response_users.message);
        myProfile();
        setCode({ status: false });
        reset();
      } else {
        toast.error(response_users.message);
      }
    }
  };
   var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
    var currentDate = moment().format("YYYY-MM-DD");
    const [filter, setFilter] = useState({
      page: 1,
      page_size: 10,
      fromPeriod: currentDate,
      toPeriod: currentDate,
      filterByDay: "",
    });
   const [data, setData] = useState({});
    const getData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getDashboard,
      {
        fromPeriod: filter?.fromPeriod,
        toPeriod: filter?.toPeriod,
      }
    );
    if (status === 200) {
      if (response_users.success) {
        setData(response_users?.results);
      }
    }
  };
    useEffect(() => {
      getData();
     myProfile();
    }, []);
  return (
    <div style={{ padding: "10px 5px" }}>
      <div className="container-xxl">
        <div
          className="py-2 "
          style={{
            display: "flex",
            "-webkit-flex-direction": "row",
            "-ms-flex-direction": "row",
            "flex-direction": "row",
            "-webkit-box-pack": "space-between",
            "-webkit-justify-content": "space-between",
            "-ms-flex-pack": "space-between",
            "justify-content": "space-between",
          }}
        >
          <h2 className="mb-0">Dashboard</h2>
          <div style={{ cursor: "pointer" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={32}
              height={32}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-rotate-ccw"
              aria-hidden="true"
            >
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
            </svg>
          </div>
        </div>
        <div className="w-100 my-2">
          <p
            style={{
              "font-size": "1rem",
              color: "rgb(238, 65, 54)",
              "font-weight": "700",
            }}
          >
            নিচের এফিলিয়েট লিংক ইডিট করে আপনার ইচ্ছা মত বানিয়ে নিন।
          </p>
          <div
            className="d-inline-flex flex-wrap py-2 mb-3 align-items-center gap-3 px-3 rounded"
            style={{ "background-color": "rgb(108, 117, 125)", color: "white" }}
          >
            <span style={{ "font-size": "clamp(1rem, 2.5vw, 1.5rem)" }}>
              https://{helpers?.getDomain()}/register/?referral_code={profileData?.referalCode}
              
            </span>
            <span
              className="p-2 rounded cursor-pointer"
              title="Copy URL"
              style={{ "line-height": "0", cursor: "pointer" }}
               onClick={() => handleCopy()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={20}
                height={20}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-copy"
                aria-hidden="true"
              >
                <rect width={14} height={14} x={8} y={8} rx={2} ry={2} />
                <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
              </svg>
            </span>
            <span title="Edit Agent" style={{ cursor: "pointer" }}
            onClick={() => {
                                      setCode({ ...code, status: true });
                                      setValue(
                                        "referalCode",
                                        profileData?.referalCode
                                      );
                                    }}
                                    >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={20}
                height={20}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-pen"
                aria-hidden="true"
              >
                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
              </svg>
            </span>
          </div>
        </div>
       <div className="row g-3 g-md-4 mb-3 mb-md-4">
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(76, 29, 36)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Total Player:
                  </span>
                 {data?.userCount}
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Valid Referral:
                  </span>
                 0
                  <span style={{ "font-size": "0.4em", margin: "0px 4px" }}>
                    |
                  </span>
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Referral:
                  </span>
                  0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Users
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <circle cx={9} cy={7} r={4} />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(139, 92, 246)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Profit:
                  </span>
                  0
                  <span style={{ "font-size": "0.4em", margin: "0px 8px" }}>
                    |
                  </span>
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Loss:
                  </span>
                  0
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Net P/L:{" "}
                  </span>
                  0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Profit &amp; Loss
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-user-check"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="m16 11 2 2 4-4" />
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(3, 123, 252)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Bonus:
                  </span>
                 0
                  <span style={{ "font-size": "0.4em", margin: "0px 8px" }}>
                    |
                  </span>
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Admin Fees:{" "}
                  </span>
                  0
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", "margin-right": "4px" }}>
                    Total:{" "}
                  </span>
                 0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Bonus &amp; Admin Fees
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-user-round"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M18 20a6 6 0 0 0-12 0" />
                <circle cx={12} cy={10} r={4} />
                <circle cx={12} cy={12} r={10} />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(16, 185, 129)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Commission:{" "}
                  </span>
                 0
                  <span style={{ "font-size": "0.4em", margin: "0px 4px" }}>
                    |
                  </span>
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Base:{" "}
                  </span>
                 0
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Total:{" "}
                  </span>
                 0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Commission
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-trending-up"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M16 7h6v6" />
                <path d="m22 7-8.5 8.5-5-5L2 17" />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(220, 38, 38)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.8em", margin: "0px 2px" }}>
                    Extra Bonus : 0 %
                  </span>
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Bonus:{" "}
                  </span>
                 0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Bonus Commission
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-trending-up"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M16 7h6v6" />
                <path d="m22 7-8.5 8.5-5-5L2 17" />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(245, 155, 0)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Current Commission:{" "}
                  </span>
                 0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Total Affiliate Payout
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-trending-up"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M16 7h6v6" />
                <path d="m22 7-8.5 8.5-5-5L2 17" />
              </svg>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div
              style={{
                "border-radius": "8px",
                color: "white",
                position: "relative",
                height: "clamp(140px, 20vw, 160px)",
                display: "flex",
                "-webkit-flex-direction": "column",
                "-ms-flex-direction": "column",
                "flex-direction": "column",
                "-webkit-box-pack": "space-between",
                "-webkit-justify-content": "space-between",
                "-ms-flex-pack": "space-between",
                "justify-content": "space-between",
                overflow: "hidden",
                "background-color": "rgb(245, 155, 0)",
              }}
            >
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    Settled Commission:{" "}
                  </span>
                 0
                </div>
                <div
                  style={{
                    "font-family": "Arial, san-serif",
                    "font-size": "clamp(24px, 4vw, 28px)",
                    margin: "8px 0px",
                    "line-height": "1",
                  }}
                >
                  <span style={{ "font-size": "0.4em", margin: "0px 2px" }}>
                    WIthdraw Commission:{" "}
                  </span>
                  0
                </div>
              </div>
              <div
                style={{
                  "font-size": "12px",
                  "font-weight": "600",
                  opacity: "0.8",
                  display: "flex",
                  "-webkit-align-items": "center",
                  "-webkit-box-align": "center",
                  "-ms-flex-align": "center",
                  "align-items": "center",
                  gap: "4px",
                  width: "100%",
                  padding: "10px",
                  background: "rgba(0, 0, 0, 0.15)",
                }}
              >
                Total Affiliate Payout
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-trending-up"
                aria-hidden="true"
                style={{
                  position: "absolute",
                  bottom: "50px",
                  right: "15px",
                  opacity: "0.4",
                  width: "64px",
                  height: "64px",
                }}
              >
                <path d="M16 7h6v6" />
                <path d="m22 7-8.5 8.5-5-5L2 17" />
              </svg>
            </div>
          </div>
        </div>
        <div className="border border-black rounded p-4">
          <ul
            style={{
              padding: "0px 5px",
              "list-style": "none",
              "font-size": "1.5em",
              "margin-bottom": "0px",
            }}
          >
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(251, 191, 36)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              নতুন খেলোয়াড়দের আমন্ত্রণ জানান
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(16, 185, 129)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              খেলোয়ারদের সাথে আপনার রেফারেল লিঙ্ক শেয়ার করুন। যখন তারা আপনার
              লিঙ্ক ব্যবহার করে নিবন্ধন করবে, তখন তারা আপনার এজেন্ট আইডির সাথে
              লিঙ্ক হয়ে যাবে।
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(139, 92, 246)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              খেলোয়াড়ের কার্যকলাপ
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(3, 123, 252)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              রেফার করা খেলোয়াড়রা বিকাশ, রকেট, অথবা নগদের মতো স্থানীয়
              ওয়ালেটের মাধ্যমে জমা করে এবং খেলা শুরু করে।
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(220, 38, 38)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              কমিশন উপার্জন করুন
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(245, 158, 11)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              খেলোয়াড়ের নিট মুনাফা: (জয়/পরাজয়) – ২০% পরিচালনা খরচ – বোনাস =
              নিট মুনাফা
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(99, 102, 241)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              আপনার কমিশন এই নিট মুনাফা এবং আপনার কমিশন স্তরের উপর ভিত্তি করে
              গণনা করা হয়।
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(24, 119, 242)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              আপনার ইনকাম উত্তোলন করুন
            </li>
            <li style={{ color: "black", "margin-bottom": "10px" }}>
              <span
                style={{ color: "rgb(6, 182, 212)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              আপনি প্রতি সপ্তাহে আপনার জমা হওয়া কমিশন উত্তোলন করতে পারেন।
            </li>
            <li style={{ color: "black" }}>
              <span
                style={{ color: "rgb(139, 92, 246)", "font-weight": "bold" }}
              >
                •{" "}
              </span>
              এটাই! খেলোয়াড়দের আনুন, তাদের খেলা উপভোগ করতে সাহায্য করুন, এবং
              আপনার উপার্জন বৃদ্ধি এবং ধনী হতে থাকুন
            </li>
          </ul>
        </div>
      </div>
      <Modal
              show={code?.status}
              onHide={() => {
                setCode({ status: false });
              }}
              className="change-status-modal p-0"
            >
              <Modal.Header closeButton>
                <Modal.Title className="modal-title-status h4">
                  Update Referal Code
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="test-status border-0">
                  <Form
                    className="change-password-sec"
                    onSubmit={handleSubmit(updateRefrel)}
                  >
                    <Form.Group className="d-flex  mb-2">
                      <Form.Control
                        type="text"
                        maxLength={8}
                        placeholder="Referal Code"
                        className={errors.referalCode ? " is-invalid " : ""}
                        {...register("referalCode", {
                          required: "Please enter referal code",
                        })}
                      />
                      {errors.referalCode && errors.referalCode.message && (
                        <label
                          className="invalid-feedback align-leftt"
                        >
                          {errors.referalCode.message}
                        </label>
                      )}
                    </Form.Group>
      
                    <div className="text-center mt-4">
                      <Button type="submit" className="green-btn">
                        Update
                      </Button>
                    </div>
                  </Form>
                </div>
              </Modal.Body>
            </Modal>
    </div>
    
  );
};

export default DashboardNew;
